module.exports = __webpack_public_path__ + "06_hair_gold.58fb87cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/06_hair_gold.png
// module id = ftSR
// module chunks = 0